import { render, staticRenderFns } from "./ReferencePriceForm.vue?vue&type=template&id=a78c15e4&scoped=true"
import script from "./ReferencePriceForm.vue?vue&type=script&lang=js"
export * from "./ReferencePriceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78c15e4",
  null
  
)

export default component.exports